export enum CHAT_REQUEST_IDENTIFIERS {
  'UNREAD_MESSAGES' = 'chat.unread.messages',
  'USER_ME' = 'chat.user.me'
}
